import { WallboxOcppDto } from '../../dto'
import { WallboxOcppModel } from '../../models'

/**
 * Transforms OCPP DTO (backend data) to OCPP Model (frontend data).
 *
 * @param dto
 * @returns
 */
export const fromOcppDtoToModelTransformer = (dto: WallboxOcppDto): WallboxOcppModel => {
  return {
    enabled: dto.enabled,
    id: dto.id,
    serverAddress: dto.serverAddress,
    authType: dto.authType === 1,
    allowLocalCharge: dto.allowLocalCharge,
    password: dto.password,
  }
}
